import { ColorPicker } from '@app/components/cms/ColorPicker';
import { Popover } from '@app/components/various/Popover/Popover';
import cx from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  disableAlpha?: boolean;
  value: string;
  onChange: (color: string) => void;
  onOpenEditor?: () => void;
  onCloseEditor?: () => void;
  className?: string;
}

export const ColorEditor = React.memo(({ disableAlpha = true, value, onChange, onCloseEditor, onOpenEditor, className }: Props) => {
  const { t } = useTranslation(['cms']);

  const handleSetColor = React.useCallback((hex: string) => onChange(hex), [onChange]);

  return (
    <div className={cx('relative flex cursor-pointer items-center justify-center gap-2 px-4', className)}>
      <Popover
        isClickable
        placement="bottom-start"
        onAppear={onOpenEditor}
        onDisappear={onCloseEditor}
        className="p-0"
        content={<ColorPicker color={value} onChangeComplete={handleSetColor} isVisible disableAlpha={disableAlpha} />}
      >
        <div className="relative flex">
          <div className="color-editor-placeholder absolute left-0 top-0 size-6 bg-white" />
          <button className="relative size-6" style={{ background: value }} aria-label={t('cms:change_color')} type="button" />
        </div>
      </Popover>
      <span style={{ width: `${value.length}ch` }} className="uppercase body-6">
        {value}
      </span>
    </div>
  );
});
